import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { OrganizationSubscription, OrganizationSubscriptionPlan } from 'src/app/models/organization';
import { Plan } from 'src/app/models/plan';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PlanService } from 'src/app/services/plan.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-add-organization-subscription-dialog',
  templateUrl: './add-organization-subscription-dialog.component.html',
  styleUrls: ['./add-organization-subscription-dialog.component.scss']
})
export class AddOrganizationSubscriptionDialogComponent {
  plans: {
    label: string,
    value: Plan,
    selected: boolean,
    disabled: boolean
  }[] = [];

  subscriptionToCreate: OrganizationSubscriptionPlan = {
    plan: undefined,
    additionalVolume: undefined,
    additionalTrademarks: undefined,
    additionalCases: undefined,
    // No price helper yet: the per-URL pricing grid is not defined, so this option
    // carries no hint and does not feed subscriptionPrice(). Add one alongside
    // additionalCasesPrice() once the commercial rate is known.
    additionalCrawlerUrl: undefined
  };

  errors: {
    [key: string]: {
      value: boolean,
      message?: string
    }
  } = {
      plan: {
        value: false,
        message: undefined
      }
    }


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthenticationService,
    private dialogRef: MatDialogRef<AddOrganizationSubscriptionDialogComponent>,
    private planService: PlanService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private utils: UtilsService
  ) {
  }

  ngOnInit(): void {
    if (this.data && this.data.subscription) {
      this.subscriptionToCreate = this.data.subscription;
      console.log(this.subscriptionToCreate)
    }

    this.retrievePlans();
  }

  ngOnDestroy(): void {
  }

  async retrievePlans() {
    try {

      this.plans = (await this.planService.retrievePlans(1, 999, 0, 'label', undefined)).docs.map((plan) => ({
        label: plan.label,
        value: plan,
        selected: this.subscriptionToCreate && this.subscriptionToCreate.plan && plan._id === this.subscriptionToCreate.plan._id ? true : false,
        disabled: false
      }));

    } catch (err) {
      this.toastr.error(`ERRORS.GENERIC`)
    }
  }

  _hasErrors() {
    this.errors['plan'] = {
      value: false,
      message: undefined
    }
    if (!this.subscriptionToCreate.plan) {
      this.errors['plan'].value = true;
      this.errors['plan'].message = this.translate.instant('ERRORS.SUBSCRIPTION_PLAN_REQUIRED');
    }

    return this.errors['plan'].value;
  }

  onPlanChange(event: any) {
    if (event && event.value && event.value.value)
      this.subscriptionToCreate.plan = event.value.value;
  }

  onCancel(): void {
    this.dialogRef.close({
      created: false
    });
  }

  async onSave() {
    if (this._hasErrors()) {
      return
    } else {
      this.dialogRef.close({
        created: true,
        subscription: this.subscriptionToCreate
      });
    }
  }

  additionalVolumePrice() {
    if (this.subscriptionToCreate && this.subscriptionToCreate.additionalVolume !== undefined) {
      return this.subscriptionToCreate.additionalVolume * 200
    }
    return undefined
  }

  additionalTrademarksPrice() {
    if (this.subscriptionToCreate && this.subscriptionToCreate.additionalTrademarks !== undefined) {
      return Math.ceil(this.subscriptionToCreate.additionalTrademarks / 5000) * 2500
    }
    return undefined
  }

  additionalCasesPrice() {
    if (this.subscriptionToCreate && this.subscriptionToCreate.additionalCases !== undefined) {
      if (this.subscriptionToCreate.additionalCases >= 1 && this.subscriptionToCreate.additionalCases <= 2) {
        return 675 * this.subscriptionToCreate.additionalCases
      } else if (this.subscriptionToCreate.additionalCases >= 3 && this.subscriptionToCreate.additionalCases <= 7) {
        return 600 * this.subscriptionToCreate.additionalCases
      } else if (this.subscriptionToCreate.additionalCases >= 8 && this.subscriptionToCreate.additionalCases <= 17) {
        return 525 * this.subscriptionToCreate.additionalCases
      } else if (this.subscriptionToCreate.additionalCases >= 18 && this.subscriptionToCreate.additionalCases <= 27) {
        return 450 * this.subscriptionToCreate.additionalCases
      } else if (this.subscriptionToCreate.additionalCases >= 28) {
        return 375 * this.subscriptionToCreate.additionalCases
      }
    }
    return undefined
  }

  subscriptionPrice() {
    if (this.subscriptionToCreate && this.subscriptionToCreate.plan !== undefined) {
      return this.subscriptionToCreate.plan?.annualPrice + (this.additionalVolumePrice() || 0) + (this.additionalTrademarksPrice() || 0) + (this.additionalCasesPrice() || 0)
    }
    return undefined;
  }
}
